'use client'
import useGlobalStore from '@/stores/global'
import { GlobalCoin } from '@/types/coin'

export default function useDisplayCoins(data: Array<{ name: string }> | undefined, limit?: number) {
  const allCoins = useGlobalStore(state => state.allCoins)
  const allCoinsSlugMap = useGlobalStore(state => state.allCoinsSlugMap)
  const existingCoins = data?.reduce((acc: GlobalCoin[], coin) => {
    const name = coin.name.trim().toLowerCase()
    if (!name) return acc
    const matched = allCoins.find(coin => coin.name.trim().toLowerCase() === name)
    const coinInfo = matched ? allCoinsSlugMap[matched.slug] : undefined
    if (coinInfo) acc.push(coinInfo)
    return acc
  }, [])

  return limit !== undefined ? existingCoins?.slice(0, limit) : existingCoins
}
